
<div class="modal-body">
  <div class="d-flex mb-5">
    <avatar class="mr-4" [user]="permission.user" *ngIf="permission.user"></avatar>
    <group-avatar class="mr-4" [group]="permission.group" *ngIf="permission.group"></group-avatar>
    <div>
      <div>{{ permission.user?.displayName || permission.group?.name }}</div>
      <div class="text-muted"><span *ngIf="permission.user" translate>User</span><span *ngIf="permission.group" [translate]="membersPlural" [translateParams]="{count: permission.group.members.length}"></span></div>
    </div>
  </div>
  <div class="form-group" *ngIf="root">
    <label translate>Allow access to</label>
    <path-selector [(ngModel)]="permission.path" [relative]="root?.fullPath" [placeholder]="'Whole Media Root'|translate"></path-selector>
  </div>
  <media-permission-editor [(permission)]="permission" [presetMode]="false" [root]="root"></media-permission-editor>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="save()" [disabled]="!isValid()" data-test-qa="save"><i class="far fa-check"></i><span translate>Save</span></button>
  <button class="btn btn-outline-secondary" (click)="cancel()" data-test-qa="cancel" translate>Cancel</button>
</div>